module.exports = __webpack_public_path__ + "ca1b5c20c849dfb549c200b18147663f.png";